





import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class CentralViewCard extends Vue {
  name = '';

  get card() {
    return this.$store.getters.getCard(this.name);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CentralViewCard.vue